<section class="trial website-container">
  <h4 class="trial-heading" [innerHTML]="'WEBSITE.TRIAL.TITLE' | translate | safe: 'html'"></h4>
  <p class="trial-description page-description">{{ 'WEBSITE.TRIAL.DESCRIPTION' | translate }}</p>
  <app-button [config]="{
        view: 'primary',
        icon: { name: 'specialArrowRight', position: 'suffix' },
        label: 'WEBSITE.TRIAL.BUTTON' | translate,
      }" [routerLink]="['/price']"></app-button>
</section>
